export default "__VITE_ASSET__MPhe_EA3__"